export default __webpack_public_path__ + "static/media/headshot-josh.044e1328.png";